// Languages a restaurant owner can pick as their second / third menu language.
// English is always the primary name and is never in this list.
//
// Mirrors rushmyfood-backend/src/utils/menuLanguages.js — keep both copies in
// sync. The backend validates the code, so an entry missing there is rejected.

export const MENU_LANGUAGES = [
  { code: 'te', english: 'Telugu', native: 'తెలుగు' },
  { code: 'hi', english: 'Hindi', native: 'हिन्दी' },
  { code: 'ta', english: 'Tamil', native: 'தமிழ்' },
  { code: 'bn', english: 'Bengali', native: 'বাংলা' },
  { code: 'gu', english: 'Gujarati', native: 'ગુજરાતી' },
  { code: 'pa', english: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
  { code: 'ur', english: 'Urdu', native: 'اردو' },
  { code: 'zh', english: 'Chinese (Simplified)', native: '中文' },
  { code: 'zh-TW', english: 'Chinese (Traditional)', native: '繁體中文' },
  { code: 'ja', english: 'Japanese', native: '日本語' },
  { code: 'ko', english: 'Korean', native: '한국어' },
  { code: 'vi', english: 'Vietnamese', native: 'Tiếng Việt' },
  { code: 'th', english: 'Thai', native: 'ไทย' },
  { code: 'tl', english: 'Filipino', native: 'Filipino' },
  { code: 'es', english: 'Spanish', native: 'Español' },
  { code: 'fr', english: 'French', native: 'Français' },
  { code: 'pt', english: 'Portuguese', native: 'Português' },
  { code: 'de', english: 'German', native: 'Deutsch' },
  { code: 'ru', english: 'Russian', native: 'Русский' },
  { code: 'ar', english: 'Arabic', native: 'العربية' },
  { code: 'so', english: 'Somali', native: 'Soomaali' },
]

export function getLanguage(code) {
  if (!code) return null
  return MENU_LANGUAGES.find((l) => l.code === code) || null
}

// "తెలుగు (Telugu)" for pickers and field labels; null when nothing is set.
export function getLanguageLabel(code) {
  const lang = getLanguage(code)
  return lang ? `${lang.native} (${lang.english})` : null
}

export function getLanguageEnglish(code) {
  const lang = getLanguage(code)
  return lang ? lang.english : null
}
